import { Box } from '@mui/material';
import { FC } from 'react';
import { AnimatedBackground } from 'ui/AnimatedBackground';

export const EASSpinner: FC = () => {
	return (
		// <div
		// 	style={{
		// 		display: 'flex',
		// 		alignContent: 'center',
		// 		justifyContent: 'center',
		// 		height: '100vh',
		// 		backgroundColor: '#016193',
		// 		color: '#016193',
		// 	}}
		// >
		// 	<div
		// 		style={{
		// 			height: '100vh',
		// 			width: '100vw',
		// 			display: 'flex',
		// 			justifyContent: 'center',
		// 			alignItems: 'center',
		// 		}}
		// 	>
		// 		<div style={{ height: '20vh' }}>
		// 			<img src="/img/EAS-spinner.svg" alt="" style={{ height: '100%' }} />
		// 		</div>
		// 	</div>
		// </div>
		<AnimatedBackground>
			<div
				style={{
					height: 'calc(100vh - 20px)',
					width: 'calc(100vw - 20px)',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: 0,
					margin: 0,
					overflow: 'hidden',
					position: 'relative',
					zIndex: 1000,
				}}
			>
				<Box
					sx={{
						height: '300px',
						width: '300px',
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						backgroundColor: '#052437',
						zIndex: 1000,
						borderRadius: '50%',
						overflow: 'hidden',
						// animationDuration: '10s',
						animationName: 'blinking',
						filter: 'blur(100px)',
						// animationIterationCount: 'infinite',
					}}
				/>
				<Box
					sx={{
						height: '200px',
						width: '200px',
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						backgroundColor: '#39d1ff',
						zIndex: 1000,
						borderRadius: '50%',
						overflow: 'hidden',
						// animationDuration: '10s',
						animationName: 'blinking',
						filter: 'blur(50px)',
						// animationIterationCount: 'infinite',
					}}
				/>

				<div style={{ height: '20vh', zIndex: 1000 }}>
					<img src="/img/EAS-spinner-invert.svg" alt="" style={{ height: '100%' }} />
				</div>
			</div>
		</AnimatedBackground>
	);
};
